import type { LinkedAccount } from 'bundles/account-settings/components/sections/delete-account/AccountDeletion.types';

import _t from 'i18n!nls/account-settings';

export const getLinkedAccountErrorMessage = (linkedAccount: LinkedAccount): string => {
  switch (linkedAccount) {
    case 'facebook':
      return _t('Please unlink your Facebook account first.');
    case 'apple':
      return _t('Please unlink your Apple account first.');
    case 'google':
      return _t('Please unlink your Google account first.');
  }
};
